import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import WordCountIndicator from './WordCountIndicator';

const ReportTextSection = ({
  label,
  field,
  helpText,
  rows = 12,
  value,
  isEditable,
  fieldStatus,
  hasError,
  onChange,
  fieldPrefix = '',
}) => (
  <Form.Group className="mb-5" id={`field-${fieldPrefix}${field}`}>
    <Form.Label className="fw-bold">{label}</Form.Label>
    {isEditable && helpText && (
      <Form.Text className="d-block text-muted mb-2">{helpText}</Form.Text>
    )}
    {isEditable ? (
      <>
        <Form.Control
          as="textarea"
          rows={rows}
          style={{ minHeight: '250px' }}
          value={value}
          onChange={(e) => onChange(field, e.target.value)}
          placeholder=""
          autoComplete="off"
          name={field}
          className={hasError || fieldStatus.over ? 'border-danger' : ''}
        />
        <WordCountIndicator
          count={fieldStatus.count}
          limit={fieldStatus.limit}
          over={fieldStatus.over}
        />
        {hasError && !fieldStatus.over && (
          <div className="text-danger small mt-1">
            <i className="fas fa-exclamation-circle me-1" />
            Required field
          </div>
        )}
      </>
    ) : (
      <div className="ps-2 mt-2" style={{ whiteSpace: 'pre-wrap' }}>
        {value?.trim() || (
          <span className="text-muted fst-italic">No response provided</span>
        )}
      </div>
    )}
  </Form.Group>
);

ReportTextSection.propTypes = {
  label: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired,
  helpText: PropTypes.string,
  rows: PropTypes.number,
  value: PropTypes.string.isRequired,
  isEditable: PropTypes.bool.isRequired,
  fieldStatus: PropTypes.shape({
    count: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    over: PropTypes.bool.isRequired,
  }).isRequired,
  hasError: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  fieldPrefix: PropTypes.string,
};

ReportTextSection.defaultProps = {
  helpText: null,
  rows: 12,
  fieldPrefix: '',
};

export default ReportTextSection;
